export const version = "bytes/5.5.0";
